import React from 'react';
import {Icon} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import useCopyToClipboard from '@/hooks/use-copy-to-clipboard';
import styles from './BriefBlocks.module.scss';

interface CopyableValueProps {
  value: string;
  label?: string | null;
  testID: string;
}

function CopyableValue({value, label, testID}: CopyableValueProps) {
  const {notification, copyText} = useCopyToClipboard();

  return (
    <div className={styles.copyRow} data-testid={testID}>
      {label ? <span className={styles.copyLabel}>{label}:</span> : null}
      <button
        type="button"
        className={styles.copyButton}
        onClick={() => copyText(value)}
        aria-label={translate('Copy to clipboard')}
      >
        <span className={styles.copyValue}>{value}</span>
        <Icon name="Navigation-Copy" size="small" appearance="neutral" />
      </button>
      {notification ? (
        <span className={styles.copyNotice} role="status">
          {notification}
        </span>
      ) : null}
    </div>
  );
}

export default CopyableValue;
